<div [class]="className">
  <agm-map [zoomControl]="disableZoomControl" [maxZoom]="16" [streetViewControl]="disableStreetViewControl"
    [fitBounds]="fitBounds" (mapClick)="mapClick($event)">
    <ng-container *ngFor="let loc of locationData">
      <ng-container *ngIf="loc.isCurrentLocation; then currentLocationTemplate else infoWindowsTemplate"></ng-container>
      <ng-template #infoWindowsTemplate>
        <agm-marker [latitude]="loc.latitude" [agmFitBounds]="fitBounds" [longitude]="loc.longitude"
          [iconUrl]="locationIcon" (markerClick)="markerClick(infoWindow, i)">
          <agm-info-window #infoWindow [maxWidth]="400">
            <div class="ya-typography">
              <a (click)="navigateToLocationDetail(loc.hyp_cus_nr)">
                <div class="map-location-content">
                  <div class="map-location-content-info">
                    <h2 class="no-margin">
                      {{loc.label}}
                    </h2>
                    <div class="ya-body-2"><span langkey="phGlobal_OpenTime"></span>: {{loc.openTime}}</div>
                  </div>
                  <div matRipple matRippleCentered="true" class="map-location-content-navigation">
                    <div class="inline-icon hyp-map-navigation-next" inlineSVG="shop-icons.svg#ya-navigate_next"></div>
                  </div>
                </div>
              </a>
              <mat-divider></mat-divider>
              <ya-customAction [actionData]="loc"
                [className]="loc.locationActions.length > 2 ? 'map-action' : 'map-action-evenly'">

              </ya-customAction>
            </div>
          </agm-info-window>
        </agm-marker>
      </ng-template>
      <ng-template #currentLocationTemplate>
        <agm-marker [latitude]="loc.latitude" [agmFitBounds]="fitBounds" [longitude]="loc.longitude"
          [iconUrl]="currentLocationIcon">
        </agm-marker>
      </ng-template>
    </ng-container>
  </agm-map>
</div>